
ADILF.define('less/less!adilf/apps/social/promo-modules/collection-promo-base/css/styles',[],function(){});